module.exports = __webpack_public_path__ + "img/arrow.32792841.svg";